// extracted by mini-css-extract-plugin
module.exports = {"container":"_38fmuYpGakW42oCQr82BBh"};